module.exports = __webpack_public_path__ + "img/login-comunicacao-indique-ganhe.263c228e.png";